import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router";
import LoadingSpinner from "@/lib/components/LoadingSpinner";
import { paths } from "@/App";
import {
  createDfyOrderStore,
  DfyOrderStoreContext,
  useDfyOrderStore,
} from "@/lib/stores/dfy-order-store/dfy-order-store";
import DfyOrderFormShell from "./DfyOrderFormShell";
import { useTeamQuery } from "@/lib/queries/team-queries";
import { useCurrentTeamMembership } from "@/lib/hooks/team-hooks";

export default function DfyOrderFormPage() {
  const { teamExternalId, orderExternalId } = useParams();

  if (!teamExternalId || !orderExternalId) {
    return null;
  }

  return (
    <DfyOrderForm
      key={`${teamExternalId}:${orderExternalId}`}
      teamExternalId={teamExternalId}
      orderExternalId={orderExternalId}
    />
  );
}

function DfyOrderForm({
  teamExternalId,
  orderExternalId,
}: {
  teamExternalId: string;
  orderExternalId: string;
}) {
  const [store] = useState(() => createDfyOrderStore());

  useEffect(() => {
    store.getState().service.initialize(teamExternalId, orderExternalId);
    return () => {
      store.getState().service.destroy();
    };
  }, [store, teamExternalId, orderExternalId]);

  return (
    <DfyOrderStoreContext.Provider value={store}>
      <DfyOrderFormLoaded />
    </DfyOrderStoreContext.Provider>
  );
}

function DfyOrderFormLoaded() {
  const isInitialized = useDfyOrderStore((state) => state.isInitialized);
  const order = useDfyOrderStore((state) => state.order);
  const { teamExternalId } = useParams();
  const orderExternalId = useDfyOrderStore((state) => state.orderExternalId);
  const { data: team } = useTeamQuery(teamExternalId!);
  const teamMembership = useCurrentTeamMembership();

  if (!isInitialized || !order || !team || !teamMembership) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (order.status !== "DRAFT") {
    return (
      <Navigate to={paths.dfyOrder(teamExternalId!, orderExternalId)} replace />
    );
  }

  return <DfyOrderFormShell />;
}
